import { useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { client } from '@cast/core';
import { notify } from '@cast/design-system';
import { RecordedData } from '@cast/shared-types';

type SaveRecordedDataInput = {
  fixturesGroup: string;
  tourStep: string;
  data: RecordedData;
};

export const useSaveRecordedDataMutation = () => {
  return useMutation({
    mutationFn: async ({
      fixturesGroup,
      tourStep,
      data,
    }: SaveRecordedDataInput) => {
      return client.post(
        `/dev-tools/recorder/${fixturesGroup}`,
        {
          tourStep,
          data,
        },
        { baseURL: '' }
      );
    },
    onSuccess: () => {
      notify.success('Demo data saved successfully!');
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
